// src/api/EmailService.js
import http from './http'

export async function sendContact(tenant, payload) {
  if (!tenant) throw new Error('Tenant em falta')

  // Se quiseres override total (ex: url já com /api/{tenant}/contact)
  const explicitUrl = process.env.VUE_APP_SEND_EMAIL
  const url = explicitUrl || `/api/${tenant}/contact`

  try {
    const res = await http.post(url, payload)

    // Backend Laravel devolve { ok: true }
    if (res?.data?.ok !== true) {
      const msg = res?.data?.error || res?.data?.message || 'Falha no envio'
      throw new Error(msg)
    }

    return res.data
  } catch (err) {
    if (err.response) {
      const msg = err.response.data?.error || err.response.data?.message || 'Erro no servidor'
      throw new Error(`Erro ${err.response.status}: ${msg}`)
    }
    if (err.request) {
      throw new Error('Erro de rede. Verifica se o backend está ativo e CORS permitido.')
    }
    throw err
  }
}
